import {
	AbstractControl,
	UntypedFormGroup,
	ValidationErrors,
	ValidatorFn,
} from '@angular/forms';

export class AuPasswordInput {
	toggleInputType(event: MouseEvent, input: HTMLInputElement): void {
		event.stopPropagation();
		input.type = input.type === 'text' ? 'password' : 'text';
	}

	getInputIcon(inputType): string {
		return inputType === 'password' ? 'eye' : 'eye_hide';
	}

	validateByPattern(regex: RegExp, error: ValidationErrors): ValidatorFn {
		return (control: AbstractControl): { [key: string]: any } | null => {
			if (!control.value) {
				return null;
			}
			const valid = regex.test(control.value);
			return valid ? null : error;
		};
	}

	mustMatch(controlName: string, matchControlName: string) {
		return (formGroup: UntypedFormGroup) => {
			const control = formGroup.controls[controlName];
			const matchingControl = formGroup.controls[matchControlName];

			if (matchingControl.errors && !matchingControl.errors.mustMatch) {
				// return if another validator has already found an error on the matchingControl
				return;
			}

			// set error on matchingControl if validation fails
			if (control.value !== matchingControl.value) {
				matchingControl.setErrors({ mustMatch: true });
			} else {
				matchingControl.setErrors(null);
			}
		};
	}
}
